import { useEffect } from 'react';

type Item = { label: string; onClick: () => void; danger?: boolean };
type Props = { at: { x: number; y: number }; items: Item[]; onClose: () => void };

export function ContextMenu({ at, items, onClose }: Props) {
  useEffect(() => {
    const close = () => onClose();
    window.addEventListener('click', close);
    window.addEventListener('keydown', close);
    return () => {
      window.removeEventListener('click', close);
      window.removeEventListener('keydown', close);
    };
  }, [onClose]);
  return (
    <div
      style={{ left: at.x, top: at.y }}
      className="fixed z-[1000] min-w-40 rounded border border-neutral-700 bg-neutral-900 py-1 text-sm shadow-lg"
    >
      {items.map((i) => (
        <button
          key={i.label}
          type="button"
          onClick={i.onClick}
          className={`block w-full px-3 py-1 text-left hover:bg-neutral-800 ${i.danger ? 'text-red-300' : ''}`}
        >
          {i.label}
        </button>
      ))}
    </div>
  );
}
